import React, { useContext, useState } from "react";
import { Box, ButtonStyled, FormEleWrapper, HeadingStyled, LabelStyled, SubHeadingStyled, TextStyled } from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import { useForm } from "react-hook-form";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { AuthContext } from "../../../context/authContext";
import { Navigate } from "react-router-dom";


const ChangePassword = () => {
	const { t } = useTranslation();
    const [formErrors, setFormErrors] = useState({});
    const { logout } = useContext(AuthContext);
	const {
        register,
        control,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
        setValue,
    } = useForm();
    const [loading, setLoading] = useState(false);

    const handleValidation = () => {
        let newErrors = {};
        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const onSubmit = async (formData) => {
        if (handleValidation()) {
          const newFormData = {
            ...formData,
            // _method: "PUT",
          };
          try {
            setLoading(true);
            const response = await ProfileApi.passwordReset(newFormData);
            if (response.code === 200) {
              toast.success(`${t('password')} ${t('Updated_Successfully')}`);
              logout();
              Navigate("/login");
            } 
            if (response.code === 100 || response.code === 204) {
                toast.error(response.message);
            }
          } catch (error) {
          } finally {
            setLoading(false);
          }
        }
      };
	return (
		<Box className="profileContentData">
            <Form onSubmit={handleSubmit(onSubmit)}>
                <FormEleWrapper className="pt-0">
                    <ValidatedInput
                        name="current_password"
                        type="input"
                        fieldType="password"
                        placeholder="OldPassword"
                        label="OldPassword"
                        className="combined px-0 py-3"
                        staric="staric"
                        register={register}
                        errors={errors}
                        validationRules={{
                            required: true,
                            
                        }}
                    />
                    <ValidatedInput
                        name="new_password"
                        type="input"
                        fieldType="password"
                        placeholder="NewPassword"
                        label="NewPassword"
                        className="combined px-0 py-3"
                        staric="staric"
                        register={register}
                        errors={errors}
                        validationRules={{
                            required: {
                              value: true,
                            },
                            inline: true,
                            minLength: {
                                value: 8,
                                message: "lengthGreaterThen",
                            },
                        }}
                    />
                    <ValidatedInput
                        name="new_password_confirmation"
                        type="input"
                        fieldType="password"
                        placeholder="ConfirmNewPassword"
                        label="ConfirmNewPassword"
                        className="combined px-0 py-3"
                        staric="staric"
                        register={register}
                        errors={errors}
                        validationRules={{
                            required: {
                              value: true,
                              message: "fieldRequired",
                            },
                            inline: true,
                            validate: (value) =>
                              value === watch("new_password") || "password_do_not_match",
                        }}
                    />
                    
                </FormEleWrapper>
                <Box className="commonBtns px-0">
                    {/* <ButtonStyled bg="var(--bgSecondary)" label={t("Cancel")} color="var(--text2)" type="button"></ButtonStyled> */}
                    <ButtonStyled label={t("Update")} type="submit" isLoading={loading}></ButtonStyled>
                </Box>
            </Form>
		</Box>
	);
};

export default ChangePassword;
